import { useState } from 'react';

// styles
import styles from './sidebar.module.scss';

// components
import { BUTTON_TYPES, Button } from 'components/Button/Button';
import { Translation } from 'components/Translation/Translation';
import { Image } from 'components/image/image';
import { SidebarItemProduct } from './SidebarItemProduct';
import { SidebarItemFullAdress } from './SidebarItemFullAdress';
import { SidebarItemEvent } from './SidebarItemEvent';
import { HotelDetail } from '../Detail/Hotel/HotelDetail';
import { ShowroomDetail } from '../Detail/showroom/showroom-detail';
import { ProductDetail } from '../Detail/Product/ProductDetail';
import { EventDetail } from '../Detail/Event/EventDetail';

// utils
import { formatDistance } from 'utils/locator';

const componentMap = {
  product: SidebarItemProduct,
  event: SidebarItemEvent,
  showroom: SidebarItemFullAdress,
  hotel: SidebarItemFullAdress,
};

const detailComponentMap = {
  product: ProductDetail,
  event: EventDetail,
  showroom: ShowroomDetail,
  hotel: HotelDetail,
};

interface SidebarItemProps {
  item: any;
  mode: string;
  showDistance: boolean | null;
  retrieveColor: any;
  handleDetail: any;
}

function SidebarItem({
  item,
  item: { category, distance },
  mode,
  showDistance = null,
  retrieveColor,
  handleDetail,
}: Readonly<SidebarItemProps>) {
  const [openAcc, setOpenAcc] = useState(false);
  const ItemView = componentMap[mode];
  const DetailView = detailComponentMap[mode];

  const handleMoreClick = () => {
    setOpenAcc(!openAcc);
    handleDetail(item, true);
  };

  const buttonTranslation = openAcc ? 'web20_locator_less_details' : 'web20_locator_more_details';
  const buttonSymbol = openAcc ? 'chevron-small-up' : 'chevron-small-down';
  let pin = mode === 'hotel' ? 'hotel-blue' : retrieveColor(category);

  if (!category) {
    pin = 'darkblue';
  }

  return (
    <ul className={styles.listItem}>
      <div className={styles.itemInfo}>
        <div className={styles.generalInfoWrapper}>
          <div className={styles.generalInfo}>
            <ItemView item={item} />
          </div>
          {showDistance && distance && (
            <div className={styles.distanceInfo}>
              <Image
                src={`/images/marker/marker-${pin}.svg`}
                alt={category}
                title={category}
                staticImage
              />
              {distance && (
                <span>
                  {formatDistance(distance)} <Translation id="web20_locator_distance_unit" />
                </span>
              )}
            </div>
          )}
        </div>
        <DetailView isAcc item={item} openAcc={openAcc} />
        <div className={styles.additionalInfo}>
          <Button
            type={BUTTON_TYPES.LINK}
            onClick={handleMoreClick}
            symbol={buttonSymbol}
            noTracking
          >
            <Translation id={buttonTranslation} />
          </Button>
        </div>
      </div>
    </ul>
  );
}

export default SidebarItem;
